var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "custom-bg p-3 rounded mt-4" },
      [
        _c("section-title", {
          staticClass: "section-title__extended mt-4",
          attrs: {
            content: "Evaluadores",
            icon: "fas fa-laptop text-orange",
            reverse: ""
          }
        }),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "d-flex col-12" },
            [
              _c("custom-drop-down", {
                staticClass: "w-25 mr-2",
                attrs: {
                  disabled: _vm.readOnly,
                  fieldkey: "userId",
                  fieldname: "fullName",
                  options: _vm.availableEvaluators,
                  placeholder: "Seleccione"
                },
                model: {
                  value: _vm.selectedEvaluator,
                  callback: function($$v) {
                    _vm.selectedEvaluator = $$v
                  },
                  expression: "selectedEvaluator"
                }
              }),
              _c("action-button", {
                attrs: {
                  disabled: _vm.readOnly,
                  i: "fas fa-user-plus",
                  text: "Asignar",
                  variant: "success mr-3 px-3"
                },
                on: { click: _vm.assignEvaluator }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("section-title", {
              staticClass: "section-title__extended mt-4",
              attrs: { content: "Información de Evaluadores" }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 my-2" },
          [_vm._t("evaluator-error")],
          2
        ),
        _vm.model && _vm.model?.length
          ? _vm._l(_vm.model, function(item, idx) {
              return _c(
                "div",
                { key: item.userId || idx, staticClass: "col-12 my-2" },
                [
                  _c("div", { staticClass: "col-12 my-2" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row custom-bg p-3 rounded align-items-center evaluator-row"
                      },
                      [
                        _c("div", { staticClass: "col-lg-3 col-md-4 col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column h-100 justify-content-center"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "text-muted d-block font-14 mb-0"
                                },
                                [_vm._v("Nombre:")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "font-16 color-black text-truncate mb-0"
                                },
                                [_vm._v(" " + _vm._s(item.fullName) + " ")]
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-3 col-md-4 col-12 mt-2 mt-md-0"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-column h-100 justify-content-center"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-muted d-block font-14 mb-0"
                                  },
                                  [_vm._v("Usuario:")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font-16 color-black text-truncate mb-0"
                                  },
                                  [_vm._v(" " + _vm._s(item.userName) + " ")]
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "col-lg-3 col-md-4 col-12 mt-2 mt-md-0"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center h-100"
                              },
                              [
                                _c("check-box", {
                                  staticClass: "row-check",
                                  attrs: {
                                    disabled: _vm.readOnly,
                                    text: "Evaluador Especializado"
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setExclusive(idx, $event)
                                    }
                                  },
                                  model: {
                                    value: item.isSpecialized,
                                    callback: function($$v) {
                                      _vm.$set(item, "isSpecialized", $$v)
                                    },
                                    expression: "item.isSpecialized"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        !_vm.readOnly
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex col-lg-3 col-12 justify-content-lg-end mt-2 mt-lg-0"
                              },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-times-circle",
                                    text: "Remover",
                                    variant: "outline-danger mr-3 px-3"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeAt(idx)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ])
                ]
              )
            })
          : _c(
              "div",
              { staticClass: "col-12" },
              [_c("custom-result-not-found")],
              1
            )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }